import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "toggle-lang" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 简体中文 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" English ")

import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { locale } = useI18n();

watch(
  () => locale.value,
  () => {
    //console.log("动态改变title")
  }
);

function translation(lang: 'zh' | 'en') {
  locale.value = lang;
}

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_check = _resolveComponent("check")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createBlock(_component_el_dropdown, {
    "popper-class": "header-lang-translation",
    trigger: "click"
  }, {
    dropdown: _withCtx(() => [
      _createVNode(_component_el_dropdown_menu, { class: "translation" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_dropdown_item, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (translation('zh'))),
            class: _normalizeClass({ active: _unref(locale) === 'zh' })
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              (_unref(locale) === 'zh')
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_check)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_dropdown_item, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (translation('en'))),
            class: _normalizeClass({ active: _unref(locale) === 'en' })
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              (_unref(locale) === 'en')
                ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_check)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_svg_icon, {
          title: "语言切换",
          icon: "lang",
          className: "toggle-icon"
        })
      ])
    ]),
    _: 1
  }))
}
}

})